import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Main } from '../../../styles/LayoutStyles';
import { checkIsMobile } from '../../../utils';
import Progress from '../../common/display/Progress';
import Footer from './Footer';
import NewHeader from './Header';

const Layout = ({ transparent = false, fixed = false, loading = false, noFooter = false, lnb, children }) => {
  return (
    <Fragment>
      <NewHeader transparent={transparent} fixed={fixed} lnb={lnb} />
      <Main transparent={transparent} fixed={fixed} isMobile={checkIsMobile}>
        {children}
      </Main>
      {loading && <Progress />}
      {!noFooter && <Footer />}
    </Fragment>
  );
};

Layout.defaultProps = {
  transparent: false,
};

Layout.propTypes = {
  transparent: PropTypes.bool,
  noFooter: PropTypes.bool,
  loading: PropTypes.bool,
  lnb: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default Layout;
